import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Alert from '@mui/material/Alert/Alert';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';

import ModalNotification from '@/shared/components/dialogs/ModalNotification';

type UnMapInventoryConfirmationDialogProps = {
  loading?: boolean;
  errors?: string[];
  onClose: () => void;
  proceed: () => void;
};

const UnMapInventoryConfirmationDialog: FC<
  UnMapInventoryConfirmationDialogProps
> = ({ loading = false, errors, onClose, proceed }) => {
  const { t } = useTranslation(['products', 'common']);

  return (
    <ModalNotification
      size='sm'
      fullWidth
      open
      onClose={onClose}
      dialogProps={{
        title: t('products:unMapInventoryDialogTitle'),
        content:
          errors && errors.length > 0 ? (
            <Stack spacing={2}>
              {errors.map((error, index) => (
                <Alert key={index} severity='error'>
                  {error}
                </Alert>
              ))}
            </Stack>
          ) : (
            <Typography>{t('products:unmapInventoryConfirmation')}</Typography>
          ),
        actions: [
          {
            label: t('common:close'),
            variant: 'text',
            onClick: onClose,
          },
          {
            label: t('common:proceed'),
            variant: 'contained',
            color: 'error',
            icon: loading && (
              <CircularProgress size={16} sx={{ color: 'inherit', mr: 2 }} />
            ),
            onClick: () => {
              if (!loading) {
                proceed();
              }
            },
          },
        ],
      }}
    />
  );
};

export default UnMapInventoryConfirmationDialog;
